import { styled, keyframes } from '@mui/material/styles';
import { usePromiseTracker } from 'react-promise-tracker';
import LoadingOverlay from 'react-loading-overlay-ts';

const spinnerSize = 4;
const spinnerPathDotSize = 0.5;
const spinnerColSecondary = '#dcdcdc';

const pathRightUpAndBack = keyframes`
  0% {
    transform: translate3d(0, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  25% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  50% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0, 0);
  }
  75% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  100% {
    transform: translate3d(0, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
`;

const pathLeftDownAndBack = keyframes`
  0% {
    transform: translate3d(${spinnerSize * (1 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  25% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  50% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, ${spinnerSize * (1 - spinnerPathDotSize / 2)}em, 0);
  }
  75% {
    transform: translate3d(${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
  100% {
    transform: translate3d(${spinnerSize * (1 - spinnerPathDotSize / 2)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0);
  }
`;

const SpinnerWrapper = styled('div')({
  position: 'relative',
  display: 'block',
  fontSize: 10,
  width: `${spinnerSize}em`,
  height: `${spinnerSize}em`,
});

const SpinnerPath = styled('span')(({ theme }) => ({
  position: 'relative',
  display: 'block',
  fontSize: 10,
  width: `${spinnerSize}em`,
  height: `${spinnerSize}em`,
  '&:before, &:after': {
    position: 'absolute',
    display: 'block',
    content: '""',
    width: `${spinnerSize * spinnerPathDotSize}em`,
    height: `${spinnerSize * spinnerPathDotSize}em`,
    borderRadius: 0,
    animationDuration: '900ms',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  '&:before': {
    backgroundColor: theme.palette.bitpix.main,
    transform: `translate3d(0, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0)`,
    animationName: `${pathRightUpAndBack}`,
  },
  '&:after': {
    backgroundColor: spinnerColSecondary,
    transform: `translate3d(${spinnerSize * (1 - spinnerPathDotSize)}em, ${spinnerSize * (0.5 - spinnerPathDotSize / 2)}em, 0)`,
    animationName: `${pathLeftDownAndBack}`,
  },
}));

const BitpixSpinner = () => (
  <SpinnerWrapper>
    <SpinnerPath />
  </SpinnerWrapper>
);

const StyledLoadingOverlay = styled(LoadingOverlay)({
  '&._loading_overlay_wrapper': {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100vh',
    zIndex: -1,
  },
  '&._loading_overlay_wrapper--active': {
    zIndex: 2147484000,
  },
});

export default function LoadingIndicator() {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <StyledLoadingOverlay
      active={promiseInProgress}
      spinner={<BitpixSpinner />}
      text=""
    />
  );
}
